<template>
  <div class="preview-area"
       v-html="$options.filters.markdown(text)">
  </div>
</template>

<script>
import {markdown} from 'markdown';
export default {
  name: 'markdown',
  props: ["text"],
  filters: {
    markdown: MDToHTML
  }
}

function DecodeHTML(value){
  var txt = document.createElement("textarea");
  txt.innerHTML = value;
  return txt.value;

}

function MDToHTML (value){
  if (!value) { return '' }
  else {
    value = value.toString();
    value = DecodeHTML(value);
    return markdown.toHTML(value); 
  }
}
</script>

<style scoped>
  .preview-area {
  font-size: 6em;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Markdown.vue